import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedFileList, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseFiles {
  search?: string;
  ordering?: string;
  limit?: string;
  athlete?: string;
}

function useFiles({
  search,
  ordering,
  athlete,
  limit = '20',
}: IUseFiles): UseInfiniteQueryResult<AxiosResponse<PaginatedFileList>> {
  const fetchFiles = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedFileList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat('');
    }

    if (athlete) {
      params.athlete = athlete;
    }

    return client.get(`files/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['files', search, ordering, athlete], fetchFiles, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useFiles;
